import { render, staticRenderFns } from "./show.page.vue?vue&type=template&id=5dc76af2&scoped=true"
import script from "./show.page.vue?vue&type=script&lang=js"
export * from "./show.page.vue?vue&type=script&lang=js"
import style0 from "./show.page.vue?vue&type=style&index=0&id=5dc76af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc76af2",
  null
  
)

export default component.exports